import React, { useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import MySelect from "../Common/MySelect";
import FireIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_fire-01.svg2";
import TerroristIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2";
import TrafficIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_terrorist-01.svg2";
import WeatherIcon from "../../assets/icons/Icon_Library/application icons/assets/events/types/type_weather.svg2";
import CreateIcon from "../../assets/icons/Icon_Library/application icons/assets/events/add_circle-01.svg2";
import MapIcon from "../../assets/icons/mapping.svg2";
import AssetIcon from "../../assets/icons/asset-01.svg2";
import MyModal from "../Common/MyModal";
import MyMap from "../Maps/MyMap";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import { SolutionEvent } from "../store/slices/settingsSlice";
import { loadAssetOptionsPaginated } from "../proxyAPI";
import Clusters from "../Maps/Clusters";
import JsonCollapse from "../Builder/Components/JsonCollapse";
import { getOverlayLocation } from "../Maps/helpers";
import MapSelection from "../Maps/MapSelection";
import { MapAssetItems, MapItems } from "../Maps/MapSidebar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faX } from "@fortawesome/free-solid-svg-icons";
import MyCollapse from "../Common/MyCollapse";
import { components } from "react-select";

const mapAssetFilters = {
  Assets: true,
  Contacts: false,
  Direct: true,
  Indirect: false,
  ExcludeWithLocation: false,
  OnlyItemsWithEvents: false,
  EventsUuids: [],
  weatherFilters: {
    isWeather: false,
    showGrids: false,
    StartAt: "",
    EndAt: "",
    range: -1,
    period: "daily",
    alertFilters: { conditionIds: [], conditions: [], search: "" },
  },
  weatherForecastFilters: {
    isForecast: false,
    start: "",
    radius: 30,
    steps: 8,
  },
  eventsFilters: {
    isEvent: false,
    severityLevel: "",
    period: "daily",
    range: -1,
  },

  Limit: 12,
  Offset: 0,
  WithContacts: true,
  Zoom: 30,
};
const mapContactFilters = {
  Assets: false,
  Contacts: true,
  Direct: true,
  Indirect: false,
  ExcludeWithLocation: false,
  OnlyItemsWithEvents: false,
  EventsUuids: [],
  weatherFilters: {
    isWeather: false,
    showGrids: false,
    StartAt: "",
    EndAt: "",
    range: -1,
    period: "daily",
    alertFilters: { conditionIds: [], conditions: [], search: "" },
  },
  weatherForecastFilters: {
    isForecast: false,
    start: "",
    radius: 30,
    steps: 8,
  },
  eventsFilters: {
    isEvent: false,
    severityLevel: "",
    period: "daily",
    range: -1,
  },

  Limit: 12,
  Offset: 0,
  WithContacts: true,
  Zoom: 30,
};

const alertOptions = [
  {
    value: "fire",
    label: (
      <span className="align-items-center">
        <FireIcon width={25} className="me-2" /> Fire
      </span>
    ),
  },
  {
    value: "terroristThread",
    label: (
      <span>
        <TerroristIcon width={25} className="me-2" /> Terrorist Thread
      </span>
    ),
  },
  {
    value: "trafficAlert",
    label: (
      <span>
        <TrafficIcon width={25} className="me-2" /> Traffic Alert
      </span>
    ),
  },
  {
    value: "weatherAlert",
    label: (
      <span>
        <WeatherIcon width={25} className="me-2" />
        Weather Alert
      </span>
    ),
  },
  {
    value: "createANewCategory",
    label: (
      <span>
        <CreateIcon width={25} className="me-2" />
        Create a new category
      </span>
    ),
  },
];

const filters = {
  Contacts: false,
  Assets: false,
  Direct: false,
  Indirect: false,
  ExcludeWithLocation: false,
  AssetUuids: [],
};

export default function EventArea({
  event,
  setEvent,
}: {
  event: Partial<SolutionEvent> | undefined;
  setEvent: React.Dispatch<
    React.SetStateAction<Partial<SolutionEvent> | undefined>
  >;
}) {
  const [selectedAsset, setSelectedAsset] = useState();
  const [overlay, setOverlay] = useState({
    show: false,
    position: { x: 0, y: 0 },
    content: <></>,
  });
  const [locationOverlays, setLocationOverlays] = useState<any[]>([]);
  const [alert, setAlert] = useState("");
  const [ignoredAssets, setIgnoredAssets] = useState<string[]>([]);

  return (
    <Row className="py-3 mt-2 ps-4 pe-4 m-2">
      <Col className="col-5 border-end pe-4">
        <div className="fs-4 fw-bold">
          Select the area affected by this event
        </div>
        <div>
          This area will be used to determine which assets and contacts are
          impacted by the event, and to trigger notifications and actions based
          on their proximity to the event location.
        </div>
      </Col>

      <Col className="col-7 ps-4">
        <div className="">
          <div>
            <div style={{ height: "500px" }}>
              <MyMap
                closeOverlay={() => setOverlay({ ...overlay, show: false })}
              >
                <MapSelection
                  drawingModes={["polygon", "rectangle"]}
                  setOverlay={setOverlay}
                  setMapBounds={() => {}}
                  setShowSidebar={() => {}}
                  showCreateEventButton={false}
                  selected={event?.Areas?.[0]?.geometry}
                  onSelect={(shape: any) => {
                    const location = shape?.overlay
                      ? getOverlayLocation(shape?.overlay)
                      : null;

                    setEvent(
                      ({ Areas, ContactsAndAssetsCriteria, ...prev }: any) => ({
                        ...prev,
                        ...(location
                          ? {
                              Areas: [
                                {
                                  type: "Feature",
                                  geometry: location.Area,
                                },
                              ],
                            }
                          : {}),
                        ContactsAndAssetsCriteria: {
                          ...ContactsAndAssetsCriteria,
                          Coordinates: location
                            ? location.Area?.coordinates
                            : undefined,
                        },
                      })
                    );
                  }}
                />
                {overlay.show && (
                  <div
                    className="position-fixed"
                    style={{
                      top: overlay.position.y - 20,
                      left: overlay.position.x + 20,
                      zIndex: 10000,
                    }}
                  >
                    {overlay.content}
                  </div>
                )}
              </MyMap>
            </div>
            {/*   </MyModal>
              )} */}

            {selectedAsset === "asset" && (
              <>
                <Input
                  placeholder="Select assets"
                  value={event?.Assets || []}
                  onChange={(values: any) => {
                    setEvent((prev) => ({
                      ...prev,
                      Assets: values,
                    }));
                  }}
                  loadOptions={loadAssetOptionsPaginated as any}
                  options={undefined}
                  inputType="select"
                  isMulti
                  isClearable
                />
              </>
            )}
          </div>
        </div>
        <div className="my-3"></div>
      </Col>
    </Row>
  );
}
